module.exports = __webpack_public_path__ + "static/media/CE_UCH_BYN.365cbb08.png";